import {Component, inject, OnInit} from '@angular/core';
import {ProfileCardComponent} from "../profile-card/profile-card.component";
import {Profile} from "../profile";
import {ProfileService} from "../profile.service";
import {CommonModule} from "@angular/common";
import {SeoService} from "../seo-service.service";

@Component({
    selector: 'app-our-team',
  imports: [
    ProfileCardComponent, CommonModule
  ],
    templateUrl: './our-team.component.html',
    styleUrl: './our-team.component.scss'
})
export class OurTeamComponent implements OnInit {

  profileService = inject(ProfileService);
  profileList: Profile[] = [];
  constructor(private seo : SeoService) {

    this.profileService.getAllProfiles()
      .subscribe({
        next: (profileList: Profile[]) => {
          this.profileList = profileList;
        },
        error: (error) => {
          console.error("Error fetching profiles:", error);
        }
      });
  }

  // for crawlers
  ngOnInit() {
    this.seo.updateMeta(
      'Meet Our Sydney Endocrinologist Team | Sydney Advanced Endocrinology',
      'Meet the team of experienced Sydney endocrinologists and healthcare professionals dedicated to providing compassionate and specialised endocrine care in Sydney.'
    );
  }
}
